import React, { useContext, useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import Maps from "../../component/Maps";
import property1 from "../../asset/images/property/big-img-01.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaArrowDown, FaSearch } from "react-icons/fa";
import {
  faBathtub,
  faBed,
  faCalendar,
  faLocation,
  faLocationArrow,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { Slider } from "@material-ui/core";
import { Link, useNavigate, useParams } from "react-router-dom";
import Detailheader from "../../component/Detailheader";
import DetailSearch from "../../component/DetailSearch";
import "swiper/css";
import "swiper/css/navigation";
import "../Custom.css";
import axios from "../../utlilites/axios";
import swal from "sweetalert";
import { SEARCH } from "../../context/Searchcontext";
const AllProperty = ({ query }) => {
  const { searchDetails, setSearchDetails } = useContext(SEARCH);
  console.log(searchDetails, "context");
  const { id } = useParams();

  //States
  const [loader, setLoader] = useState(false);
  const [allproperty, setAllproperty] = useState();
  const navigate = new useNavigate();


  useEffect(() => {
    setAllproperty(searchDetails);
  }, [searchDetails]);
  return (
    <>
      <Detailheader />
      {loader ? <div className="loader"></div> : null}
      <section className="">
        <div className="container mb-3">
          <div className="row">
            <div className="col-lg-12 pt-3">
              <DetailSearch classna="text-dark" />

              {/* card 1 */}
              {allproperty?.map((e) => {
                return (
                  <>
                    <div className="row">
                      <div className="offset-lg-2 col-lg-8 col-md-8 col-sm-12 mb-1">
                        <div>
                          <div className="card mt-1 box_shadow ">
                            <div className="row">
                              <div className="col-md-5">
                                <div className="">
                                  <img
                                    src={`http://flexrental.dev-um.xyz/storage/${e?.cover_photo}`}
                                    className=""
                                    width={"300px"}
                                    height={"300px"}
                                  />
                                </div>
                              </div>
                              <div className="col-md-7 d-flex align-items-center">
                                <div
                                  onClick={() =>
                                    navigate("/listingdetail" + e.id)
                                  }
                                >
                                  <div className="py-3 ps-1 d-flex flex-column">
                                    <p >
                                      <span className="h4">{e?.rate_per_night} $ &nbsp; </span>
                                      Rate Per Night
                                    </p>
                                    <h5>{e?.address}</h5>
                                    <span>
                                      <FontAwesomeIcon icon={faBed} />
                                      &nbsp;
                                      <span className="fw-bolder">
                                        Bedrooms  {e?.no_of_bedrooms}  |
                                        &nbsp;&nbsp;
                                      </span>
                                      <FontAwesomeIcon icon={faBathtub} />
                                      &nbsp;&nbsp;
                                      <span className="fw-bolder">
                                        Bathrooms {e?.no_of_bathrooms}{" "} |
                                      </span>

                                      &nbsp;&nbsp;
                                      <FontAwesomeIcon icon={faUser} />
                                      &nbsp;&nbsp;
                                      <span className="fw-bolder">
                                        Guest {e?.no_of_guest_allowed}
                                        &nbsp;&nbsp;
                                      </span>
                                    </span>
                                    <h4 className="mt-2">{e?.title}</h4>
                                    <div className="d-flex justigy-content-center align-items-center">
                                      <img
                                        src={`http://flexrental.dev-um.xyz/storage/${e?.user?.image}`}
                                        className="searchImg"
                                      />
                                      <p className="text-secondary fs-6 ms-3">
                                        {e?.user?.first_name}{" "}
                                        {e?.user?.last_name}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
          </div>
        </div>


      </section>
    </>
  );
};

export default AllProperty;
